<template>
  <cube-page title="大客户分析">
    <div v-if="showPage" class="root" slot="content">
      <div class="time">
        <span class="text">商业流向：{{ currentYearStr + ' 至 ' + ddiDate.format("YYYY-MM-DD") }} </span>
        <span class="text">连锁流向：{{ monthMinDate + ' 至 ' + monthDate.format("YYYY-MM-DD") }} </span>
      </div>
      <div class="body">
        <div class="common" @click="joinTownDetail()">
          <div class="logo">
            <img class="icon" :src="joinTownData.pictureUrl" />
          </div>
          <div class="data-display">
            <p>九州通一级全产品购进</p>
            <div class="fl">
              <p></p>
              <p>当月</p>
              <p>全年完成</p>
              <p>同期</p>
              <p>同比</p>
            </div>
            <div class="jcenter">
              <div class="count">
                <p>{{ (parseFloat(joinTownData.amount | 0) / 10000).toFixed(0) }}</p>
                <p>{{ (parseFloat(joinTownData.yearAmount | 0) / 10000).toFixed(0) }}</p>
                <p>{{ (parseFloat(joinTownData.samePeriodLastYear | 0) / 10000).toFixed(0) }}</p>
                <p>{{ joinTownData.comparedWithLastYear === null ? '-' : joinTownData.comparedWithLastYear }}</p>
              </div>
            </div>
            <div class="fr">
              <div class="junits">
                <p>万元</p>
                <p>万元</p>
                <p>万元</p>
                <p>%</p>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, index) in listData" :key="index">
          <div class="common" @click="detail(item, index)">
            <div class="logo">
              <img class="icon" :src="item.pictureUrl" />
            </div>
            <div class="data-display">
              <div class="fl">
                <p>60袋龙牡连锁</p>
                <!-- <p>全年累计</p> -->
                <p>剔除赠品后</p>
                <p>剔赠后同期</p>
                <p>剔赠后同比</p>
              </div>
              <div class="center">
                <div class="count">
                  <p>购进</p>
                  <!-- <p>{{ Number(item.yearTotalCount | 0).toLocaleString() }}</p> -->
                  <p>{{ Number(item.yearTotalCountWithoutGift | 0).toLocaleString() }}</p>
                  <p>{{ Number(item.lastYearTotalCountWithoutGift | 0).toLocaleString() }}</p>
                  <p>{{ item.comparedTotalCountWithoutGift === null ? '-' : item.comparedTotalCountWithoutGift }}</p>
                </div>
              </div>
              <div class="rcenter">
                <div class="count">
                  <p>/&nbsp;纯销</p>
                  <p>/&nbsp;{{ Number(item.storeYearTotalCountWithoutGift | 0).toLocaleString() }}</p>
                  <p>/&nbsp;{{ Number(item.storeLastYearTotalCountWithoutGift | 0).toLocaleString() }}</p>
                  <p>/&nbsp;{{ item.storeComparedTotalCountWithoutGift === null ? '-' : item.storeComparedTotalCountWithoutGift }}</p>
                </div>
              </div>
              <div class="fr">
                <div class="units">
                  <!-- <p>盒</p> -->
                  <p>盒</p>
                  <p>盒</p>
                  <p>%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </cube-page>
</template>

<script>
import { getBigCustomerJointown, getBigCustomerList, getFlowTime } from '@/api/bigCustomer'
import CubePage from '../../components/cube-page'
import moment from 'moment'

export default {
  name: 'KeyAccountAnalysis',
  components: {
    CubePage
  },
  data () {
    return {
      showPage: false,
      joinTownData: {},
      monthDate: undefined,
      monthMinDate: undefined,
      ddiDate: undefined,
      currentYearStr: undefined,
      listData: []
    }
  },
  created () {
    getFlowTime().then((res) => {
      if (res.code === 1) {
        // this.ddiDate = moment(res.data.ddiMaxDay)
        this.ddiDate = moment(res.data.ddiMaxDay || res.data.monthMaxDay)
        this.currentYearStr = this.ddiDate.format('YYYY') + '-01-01'
        this.monthDate = moment(res.data.monthMaxDay)
        this.monthMinDate = this.monthDate.format('YYYY') + '-01-01'
        const params = {
          date: this.ddiDate.format('YYYY-MM-DD')
        }
        const listParams = {
          date: this.monthDate.format('YYYY-MM-DD')
        }
        getBigCustomerJointown(params).then((res) => {
          if (res.code === 1) {
            this.joinTownData = res.data
            this.showPage = true
          }
        })

        getBigCustomerList(listParams).then((res) => {
          if (res.code === 1) {
            this.listData = res.data
          }
        })
      }
    })
  },
  methods: {
    joinTownDetail () {
      this.$router.push({
        name: 'joinTownDetail',
        query: {}
      })
    },
    detail (item) {
      this.$router.push({
        name: 'detail',
        query: { customerName: item.chainBrand }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.root {
  background-color: #f4f7fd;
  padding-top: 30px;

  .time {
    font-size: 18px;
    color: #666666;
    margin: 0 30px 30px 30px;

    .text {
      margin: 5px 10px;
    }
  }

  .body {
    width: 100%;
    padding: 0px 30px 30px 30px;

    .common {
      height: 290px;
      background-color: #ffffff;
      border-radius: 14px;
      margin-bottom: 30px;

      .logo {
        margin: 45px 20px;
        float: left;
        width: 180px;
        height: 180px;
        background-color: #f3f6fd;
        border-radius: 50%;

        .icon {
          width: 180px;
          height: 180px;
        }
      }

      .data-display {
        float: left;
        height: 290px;
        width: 440px;
        margin-top: 30px;
        font-size: 24px;

        .fl {
          float: left;
          width: 43%;

          p {
            margin-bottom: 20px;
          }
        }
        .jcenter {
          margin-top: 12px;
          float: left;
          width: 24%;
        }
        .center {
          float: left;
          width: 24%;
        }

        .count {
          p {
            color: #333333;
            margin-bottom: 20px;
            white-space: nowrap; // 测试环境 空格后换行
          }
        }

        .rcenter {
          float: left;
          width: 18%;
        }

        .count {
          p {
            color: #333333;
            margin-bottom: 20px;
          }
        }

        .fr {
          float: left;
          width: 15%;

          .junits {
            margin-top: 12px;
            float: right;

            p {
              margin-bottom: 20px;
            }
          }

          .units {
            margin-top: 56px;
            float: right;

            p {
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
